/** 認証 */
import EdiRequestAuthentication from './authentication'

/** 申請画面 */
import EdiRequestRegistration from './registration'

/** 新規 */
import EdiRequestUnsubscribed from './unsubscribed'
/** JWNET申請あり */
import EdiRequestSubscribed from './subscribed'

const EdiRequestlModules = {
  EdiRequestAuthentication,
  EdiRequestRegistration,
  EdiRequestUnsubscribed,
  EdiRequestSubscribed,
}
export default EdiRequestlModules
